import { Component, inject, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { first } from 'rxjs';
import { getClientTimezone } from 'src/app/common/app.helpers';
import { OperationInfoService } from 'src/app/common/long-operations/operation-info.service';
import { ManageProfileService } from 'src/app/components/profile/manage-profile.service';
import { LoginForm } from '../auth-form.inteface';
import { AuthShared } from '../auth-shared.abstract';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends AuthShared<LoginForm> implements OnDestroy {
  private operationInfoService = inject(OperationInfoService);
  private manageProfileService = inject(ManageProfileService);

  public override ngOnInit(): void {
    super.ngOnInit();

    this.subscriptions$.push(
      this.authService.reactivatePetitionTriggers$.subscribe((email: string) => {
        this.sendReactivationPetition(email);
      }),
    );
  }

  public login(): void {
    if (this.form.invalid) {
      this.validateAllFields();
      return;
    }

    const { email, password } = this.form.getRawValue();

    this.operationInfoService.setupOperation(
      {
        spinner: 'global',
        button: { id: 'login-form-login-btn' },
      },
      () => {
        this.authService.login({ email: email.trim(), password: password.trim() }, getClientTimezone());
      },
    );
  }

  protected initializeForm(): void {
    this.form = new FormGroup({
      email: new FormControl('', this.validationService.getValidators('email')),
      password: new FormControl('', this.validationService.getValidators('oldPassword')),
    });

    this.validationService.setMaxInputLength(this.form, 'email');

    this.validatePasswordChanges('password');
  }

  private sendReactivationPetition(email: string): void {
    this.manageProfileService.confirmSendReactivationPetition(email).pipe(first()).subscribe();
  }
}
